// src/api/attachInterceptors.js
import { refreshAccessToken } from './tokenUtils';

export const attachAuthInterceptors = (axiosInstance, logout) => {
  axiosInstance.interceptors.request.use(config => {
    const token = localStorage.getItem('access');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  axiosInstance.interceptors.response.use(
    res => res,
    async err => {
      const originalRequest = err.config;

      const is401 = err.response?.status === 401;
      const hasRefresh = !!localStorage.getItem('refresh');

      console.log("📌 401 감지됨?", is401);
      console.log("📌 refresh 있음?", hasRefresh);
      console.log("📌 originalRequest._retry", originalRequest._retry);

      if (is401 && !originalRequest._retry) {
        if (hasRefresh) {
          originalRequest._retry = true;
          try {
            const newAccess = await refreshAccessToken();
            originalRequest.headers.Authorization = `Bearer ${newAccess}`;
            return axiosInstance(originalRequest);
          } catch (refreshError) {
            console.error("❌ 토큰 갱신 실패", refreshError);
          }
        }

        // ✅ refresh 없거나, 갱신 실패 시 모두 여기서 logout
        console.warn("❌ refresh 없음 또는 갱신 실패 - 로그아웃 진행");
        localStorage.removeItem('access');
        localStorage.removeItem('refresh');
        logout?.();
        window.location.href = '/login';
      }

      return Promise.reject(err);
    }
  );
};